import {
  styled,
  Dialog,
  dialogClasses,
  DialogActions,
  CardContent,
  Chip,
  chipClasses,
} from '@mui/material';

export const DialogRebillOrdersContainer = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    maxWidth: 690,
    width: '100%',
  },
});

export const DialogRebillOrdersActions = styled(DialogActions)({
  justifyContent: 'space-between',
});

export const DialogRebillOrdersCardModeContent = styled(CardContent)(
  ({ theme }) => ({
    padding: theme.spacing(1, 2),

    '&:last-child': {
      paddingBottom: theme.spacing(2),
    },
  }),
);

export const DialogRebillOrdersRecommendedChip = styled(Chip)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(10),
  fontWeight: theme.typography.fontWeightBold,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.getContrastText(theme.palette.primary.main),
  height: 'auto',

  [`& .${chipClasses.label}`]: {
    padding: theme.spacing(0.5, 1.5),
  },
}));
